export default function createExternalPanelPackage(data) {
  return {
    id: data.id,
    name: data.name,
    type: data.type,
    fixedCost: data.fixed_cost,
    discountPercent: data.discount_percent,
  };
}
